import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PostsService } from 'src/app/service/posts.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-post',
  templateUrl: './add-post.component.html',
  styleUrl: './add-post.component.scss'
})
export class AddPostComponent {

  @ViewChild('img') fileInput!: ElementRef;
  @ViewChild('title') title!: ElementRef;
   @ViewChild('videoLink') videoLink!: ElementRef;
   @ViewChild('otherDescription') otherDescription!: ElementRef;
  
  
  constructor(private postsService: PostsService) { }

  ngOnInit(): void {
  }

  pageTitle = [
    {
      bgImage: 'assets/img/page-title-bg.jpg',
      title: 'Profile Authentication'
    }
  ]

  savedId:string='NO';
  fileSelected :boolean=false;
  submit(form:any) {

    var postTitle = form.postTitle;
    console.log(postTitle);

    var postDesciption = form.description;
    console.log(postDesciption);

    var keywords = form.keywords;

    let details = {
      'postTitle': postTitle,
      'postDesciption': postDesciption,
      'keywords':keywords

    }

    const uploadFormData = new FormData();
    uploadFormData.append('file', this.selectedFileVehicelReg!);
    uploadFormData.append('details', JSON.stringify(details));
    this.postsService.saveDetails(uploadFormData).subscribe(res => {
      var status = res.status;
      if (status == 'success') {
        this.fileSelected = false;
        this.savedId = res.id;
        Swal.fire({
          title: 'Successfully added the main details!',
        }).then((result) => {
        
        })
      } else {
         this.savedId = "Error";
        Swal.fire({
          title: 'Error with saving the main details!',
        }).then((result) => {
          
        })
      }
    })



  }

  fileSizeInBytes: any;
  public selectedFileVehicelReg: File | null = null;

  //public selectedFileVehicelReg: any = File;
  onFileSelectedVehicleReg(event: any) {
    const file = event.target.files[0];
    this.fileSizeInBytes = file.size;
    if (this.fileSizeInBytes > 10485760) {
      Swal.fire({
        title: 'Size of image should be less than 10240kb!',
      }).then((result) => {
      })
    } else {
      this.fileSelected = true;
      this.selectedFileVehicelReg = file;
    }



  }


  //*******************Other Details ************* */
     otherId:number=0;
  submitOtherDetails(title:any,videoLink:any,description:any){
    if(this.savedId=='NO'){
      Swal.fire({
          title: 'Please saved the main details!',
        }).then((result) => {
         
        })
    }else{
      let details = {
      'title': title,
      'videoUrl':videoLink,
      'otherDescription':description,
      'mainId':this.savedId,
      'imageUrl':'',
      'imageName':''
    }

    const uploadFormData = new FormData();
    //uploadFormData.append('file', this.selectedFileVehicelReg);
    uploadFormData.append('details', JSON.stringify(details));
    this.postsService.saveOtherDetails(uploadFormData).subscribe(res => {
      var status = res.status;
      if (status == 'success') {
        Swal.fire({
          title: 'Successfully added details!',
        }).then((result) => {
          console.log(" this.selectedFileVehicelReg  "+ !this.selectedFileVehicelReg  +" this.selectedFileVehicelReg!=null "+(this.selectedFileVehicelReg!=null));
          if (this.fileSelected) {
            this.uploadOtherImage(res.id)
          }else{
               this.title.nativeElement.value = ''; 
           this.fileInput.nativeElement.value = ''; 
           this.otherDescription.nativeElement.value='';
           this.videoLink.nativeElement.value='';
           this.selectedFileVehicelReg=null;
           this.fileSelected = false;
          }
        
         
        })
      } else {
        Swal.fire({
          title: 'Error with saving the details!',
        }).then((result) => {
         
        })
      }
    })
    }
    
  }

  uploadOtherImage(id:any){
    let details = {
      'id':id
    }
    const uploadFormData = new FormData();
    uploadFormData.append('file', this.selectedFileVehicelReg!);
        uploadFormData.append('details', JSON.stringify(details));
    this.postsService.editOtherImage(uploadFormData).subscribe(res => {
      console.log("editOtherImage "+JSON.stringify(res));
      var status = res.status;
      console.log("(status=='success') "+(status=='success'));
      if(status=='success'){ 
          this.title.nativeElement.value = ''; 
           this.fileInput.nativeElement.value = ''; 
           this.otherDescription.nativeElement.value='';
           this.videoLink.nativeElement.value='';
           this.selectedFileVehicelReg=null;
           this.fileSelected = false;
      }

    })
  }

}
